/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { HAS_JOURNEY_BUILDER_BR, HAS_LIGHTNING_HOMEPAGE_BR } from '../constants';

export default function localization(state = { hasCalendarAccess: false }, action) {
  switch (action.type) {
    case HAS_JOURNEY_BUILDER_BR: {
      if (action.payload.response && action.payload.response.data) {
        return {
          ...state,
          hasJourneyBuilderBusinessRule: true,
        };
      }

      return {
        ...state,
        hasJourneyBuilderBusinessRule: false,
      };
    }
    case HAS_LIGHTNING_HOMEPAGE_BR: {
      if (action.payload.response && action.payload.response.data) {
        return {
          ...state,
          hasLightningHomepageBusinessRule: true,
        };
      }

      return {
        ...state,
        hasLightningHomepageBusinessRule: false,
      };
    }
    default: {
      return state;
    }
  }
}
